import {
  BillingPublisherInvoiceStatus,
  BillingPublisherWithdrawalStatus,
} from 'respona_api/generated/common_pb';

import { isFeatureEnabled } from '@utils/featureFlags';

// eslint-disable-next-line @typescript-eslint/no-var-requires, global-require
export const directDepositImg = require('@assets/direct-deposit.png').default;
// eslint-disable-next-line @typescript-eslint/no-var-requires, global-require
export const wiseImg = require('@assets/wise.png').default;

export const INVOICE_STATUS_LABELS: Record<number, string> = {
  [BillingPublisherInvoiceStatus.PUBLISHER_INVOICE_PENDING_INDEXING]: 'Pending indexing',
  [BillingPublisherInvoiceStatus.PUBLISHER_INVOICE_PENDING_APPROVAL]: 'Pending approval',
  [BillingPublisherInvoiceStatus.PUBLISHER_INVOICE_PAID]: 'Approved',
  [BillingPublisherInvoiceStatus.PUBLISHER_INVOICE_REFUNDED]: 'Rejected',
};

export const WITHDRAWAL_STATUS_LABELS: Record<number, string> = {
  [BillingPublisherWithdrawalStatus.WITHDRAWAL_PAID]: 'Paid',
  [BillingPublisherWithdrawalStatus.WITHDRAWAL_FAILED]: 'Failed',
  [BillingPublisherWithdrawalStatus.WITHDRAWAL_REFUNDED]: 'Refunded',
  [BillingPublisherWithdrawalStatus.WITHDRAWAL_PROCESSING]: 'Processing',
};

export const mapInvoiceStatus = (status: number): string => INVOICE_STATUS_LABELS[status] ?? '—';
export const mapWithdrawalStatus = (status: number): string =>
  WITHDRAWAL_STATUS_LABELS[status] ?? '—';
